module.exports = __webpack_public_path__ + "img/big-logo.7fda59b.svg";